import * as actionType from "./ActionTypes";
import { filter } from "lodash";

export default function TractorETAReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.TRACTOR_ETA_DATA_LOADING:
      return (state = payload);
    case actionType.TRACTOR_ETA_DELETE_ROW:
      for (let i = 0; i < payload.deleteIdPayload.length; i++) {
        state = filter(state, function (datas) {
          return datas.TractorETAId !== parseInt(payload.deleteIdPayload[i]);
        });
      }
      payload.statePayload(state)
      return state
    default: 
      return  state;
  }
}
